import React from 'react';
import { withRouter } from 'react-router-dom';
import SegmentWrapper from './SegmentWrapper';

class RouteChangeHandler extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      trackPageViews();
    }
  }

  componentDidMount() {
    trackPageViews();
  }

  render() {
    return <SegmentWrapper/>
  }
}

const trackPageViews = () => {
  if (window.analytics?.page){
    window.analytics.page({
      page_path: window.location.pathname,
      page_url: window.location.href,
    });
  }
}

export default withRouter(RouteChangeHandler)